import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import style from './style.scss';

function TicketText({ cost }) {
  return (
    <div>
      <span className={style.ticketFrom}>from</span>
      <span className={style.ticketPrice}>${cost}</span>
    </div>
  );
}
function FreeTicketText() {
  return <div className={style.freeTicketPrice}>Complimentary event</div>;
}

TicketText.propTypes = {
  cost: PropTypes.string,
};

function Ticket({ event }) {
  const tickets = event.get('tickets');
  if (!tickets) {
    return <span />;
  }
  const containsFreeTicket = tickets.some(ticket => ticket.get('free'));
  if (containsFreeTicket) {
    return <FreeTicketText />;
  }

  const lowestPricedTicket = tickets.reduce((lowestTicket, ticket) => {
    const cost = ticket.getIn(['cost', 'value']);
    const lowestCost = lowestTicket.getIn(['cost', 'value']);
    return cost < lowestCost ? ticket : lowestTicket;
  });

  if (!lowestPricedTicket.getIn(['cost', 'display'])) {
    return <FreeTicketText />;
  }
  return (
    <TicketText
      cost={lowestPricedTicket.getIn(['cost', 'display'])}
      currency={event.get('currency')}
    />
  );
}

Ticket.propTypes = {
  event: PropTypes.instanceOf(Map),
};

export default Ticket;



// WEBPACK FOOTER //
// ./src/widget/event_components/ticket.js